// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__-nXZ1","title":"AfterFrontImage_title__2W76p"};